{
  "chapel": {
    "nave": {
      "u0": -27,
      "u1": -3,
      "v0": -18.3,
      "v1": -8.3,
      "eaves": 11.4,
      "ridge": 16.8,
      "bays": 6
    },
    "choir": {
      "u0": -3,
      "chordU": 13,
      "vc": -13.3,
      "half": 4.2,
      "eaveY": 7.9,
      "ridgeY": 12.2,
      "apse": "polygonal"
    },
    "navePixel": [2055, 2626],
    "choirPixel": [1926, 2696],
    "note": "High nave with two window bands and lower eastern choir are image readings. Dimensions, glazing and internal gallery level are estimates; later school and house fronts are excluded."
  },
  "ranges": [
    {
      "id": "barndesteeg-refter",
      "u0": -43,
      "u1": -10,
      "v0": 9.5,
      "v1": 18.3,
      "alongU": true,
      "eaves": 6.7,
      "ridge": 11.5,
      "floors": 2,
      "roof": "slate",
      "blindSide": 2,
      "pixel": [2090, 2783],
      "evidence": "observed",
      "note": "Western Barndesteeg hall. Oldest surviving roof dated 1487–1490 by BMA; roof, footprint and openings fitted to period images, not copied from the altered modern facade."
    },
    {
      "id": "barndesteeg-lower-range",
      "u0": -10,
      "u1": 33,
      "v0": 12,
      "v1": 18.3,
      "alongU": true,
      "eaves": 4.8,
      "ridge": 8.5,
      "floors": 1,
      "roof": "tile",
      "blindSide": 2,
      "pixel": [2004, 2813],
      "evidence": "observed",
      "note": "Lower connected roof mass along Barndesteeg; use unassigned range rather than inventing its room function."
    },
    {
      "id": "kloveniersburgwal-wing",
      "u0": 33,
      "u1": 40,
      "v0": -18.3,
      "v1": 12,
      "alongU": false,
      "eaves": 6.3,
      "ridge": 10.2,
      "floors": 2,
      "roof": "tile",
      "blindSide": -1,
      "pixel": [1878, 2734],
      "evidence": "observed",
      "note": "Continuous wing parallel to Kloveniersburgwal. BMA dates timbers at current numbers 10–14 to 1498 and relates them to the 1498 frontage realignment; later separated and raised house facades are excluded."
    },
    {
      "id": "achterburgwal-front-01",
      "u0": -43,
      "u1": -29,
      "v0": -18.3,
      "v1": -14.1,
      "alongU": true,
      "eaves": 7.1,
      "ridge": 10.4,
      "floors": 2,
      "roof": "tile",
      "blindSide": -1,
      "pixel": [1220, 2195],
      "evidence": "woodcut",
      "note": "First of four exposed small canal-front gables beside the chapel. Property divisions and hidden depth are estimates."
    },
    {
      "id": "achterburgwal-front-02",
      "u0": -43,
      "u1": -29,
      "v0": -14.1,
      "v1": -9.9,
      "alongU": true,
      "eaves": 7.4,
      "ridge": 10.5,
      "floors": 2,
      "roof": "tile",
      "blindSide": -1,
      "pixel": [1230, 2211],
      "evidence": "woodcut",
      "note": "Second exposed canal-front gable; estimated property."
    },
    {
      "id": "achterburgwal-front-03",
      "u0": -43,
      "u1": -29,
      "v0": -9.9,
      "v1": -5.7,
      "alongU": true,
      "eaves": 6.8,
      "ridge": 9.9,
      "floors": 2,
      "roof": "slate",
      "blindSide": -1,
      "pixel": [1241, 2226],
      "evidence": "woodcut",
      "note": "Third exposed canal-front gable; estimated property and roof covering."
    },
    {
      "id": "achterburgwal-front-04",
      "u0": -43,
      "u1": -29,
      "v0": -5.7,
      "v1": -1.5,
      "alongU": true,
      "eaves": 6.2,
      "ridge": 9.2,
      "floors": 2,
      "roof": "tile",
      "blindSide": -1,
      "pixel": [1250, 2243],
      "evidence": "woodcut",
      "note": "Fourth exposed canal-front gable, before the access gap; estimated property."
    },
    {
      "id": "achterburgwal-entry-wing",
      "u0": -43,
      "u1": -29,
      "v0": 1.5,
      "v1": 9.5,
      "alongU": true,
      "eaves": 5.8,
      "ridge": 9.2,
      "floors": 2,
      "roof": "tile",
      "blindSide": -1,
      "pixel": [1270, 2286],
      "evidence": "woodcut",
      "note": "Larger northern front wing. The canal entry is documented at current OZ Achterburgwal 117; the gap width and portal are estimates."
    }
  ],
  "court": {
    "u0": -28.5,
    "u1": 32.5,
    "v0": -7.8,
    "v1": 9
  },
  "garden": { "u0": 10, "u1": 32.5, "v0": -7.8, "v1": 9, "rows": 3, "columns": 3 },
  "entry": {
    "u0": -44.2,
    "u1": -28.5,
    "v0": -1.5,
    "v1": 1.5
  },
  "roofGables": [-33, -24, -15],
  "note": "1538 painting and 1544 woodcut control the mass hierarchy. Later Beudeker/Rademaker and Jacob de Vlaming views are comparative reconstructions. All metre dimensions and unexposed construction are provisional. No later Hoogkamersgang, 1592 portal or modern refectory facade."
}
